import actions from './actions';

let currentUser = null;
let idToken = null;
let isLoggedIn = false;
const storedCurrentUser = localStorage.getItem("currentUser");
if (storedCurrentUser && storedCurrentUser !== "undefined") {
  try {
    const _currentUser = JSON.parse(storedCurrentUser);
    currentUser = _currentUser.user ?? _currentUser;
    idToken = localStorage.getItem("token");
    isLoggedIn = idToken ? true : false;
  } catch (error) {
    console.error("Error parsing currentUser from localStorage:", error);
    localStorage.removeItem("currentUser");
    localStorage.removeItem("token");
  }
}

const initState = { isLoggedIn, idToken, currentUser};

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      return {
        isLoggedIn: true,
        idToken: action.payload.token,
        currentUser: action.payload.user,
      };
    case actions.LOGOUT:
      localStorage.removeItem("currentUser");
      localStorage.removeItem("token");

      return { isLoggedIn: false, idToken: null, currentUser: null};
    default:
      return state;
  }
}
